import { LinearProgress, withStyles } from '@material-ui/core';

export const ShareProgressBar = withStyles((theme) => ({
    root: {
        height: 6,
        borderRadius: 3,
        backgroundColor: theme.palette.secondary.light,
    },
    bar: {
        borderRadius: 3,
        backgroundColor: theme.palette.primary.main,
    },
}))(LinearProgress);
